/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { useGetLearningPathOverview } from '@queries/core/learningPath';
import { selectToken } from '@redux/slices/userSlice';
import { FullPageLoader } from 'learning-panel-components';
import { coreService } from 'network-utils';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LearningPathOverview from './learningPathOverview';

interface LearningPathOverviewContainerProps {
    learningPathUuid: string;
    onClose: (...args: any[]) => any;
}

const LearningPathOverviewContainer: FC<LearningPathOverviewContainerProps> = ({ learningPathUuid, onClose }) => {
    const token = useSelector(selectToken);
    const [learningPathOverview, setLearningPathOverview] = useState<coreService.LearningPathOverview>();
    const { data: learningPathOverviewData, isLoading } = useGetLearningPathOverview(learningPathUuid, token);

    useEffect(() => {
        if (learningPathOverviewData) {
            setLearningPathOverview(learningPathOverviewData);
        }
    }, [learningPathOverviewData]);

    if (isLoading) {
        return <FullPageLoader />;
    }

    return (
        (learningPathOverview && (
            <LearningPathOverview learningPathOverview={learningPathOverview} onClose={onClose} />
        )) ||
        null
    );
};

export default LearningPathOverviewContainer;
